import { render, staticRenderFns } from "./contractDetails.vue?vue&type=template&id=36ba7fd0&scoped=true"
import script from "./contractDetails.vue?vue&type=script&lang=js"
export * from "./contractDetails.vue?vue&type=script&lang=js"
import style0 from "./contractDetails.vue?vue&type=style&index=0&id=36ba7fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba7fd0",
  null
  
)

export default component.exports